<template>
  <section id="hero" data-component="hero">
    <LazyBg :src="bgSrc" eager />
    <canvas ref="canvasEl" id="hero-canvas">您的浏览器不支持 Canvas 动画</canvas>
    <div class="hero-overlay" />
    <div class="hero-content">
      <div class="hero-badge reveal">
        <span class="hero-badge-dot" />
        致力为云游戏行业提供最优质的解决方案
      </div>
      <h1 class="display-xl hero-title reveal reveal-delay-1">
        释放算力<br /><span class="gradient-text">连接未来</span>
      </h1>
      <p class="hero-subtitle reveal reveal-delay-2">
        海曦技术专注国产化智算中心解决方案，提供从机房建设、运维、运营到IaaS/PaaS交付的一体化算力服务，战略聚焦云游戏与AI加速场景
      </p>
      <div class="hero-actions reveal reveal-delay-3">
        <a href="#core-capabilities" class="btn-primary" @click.prevent="scrollTo('#core-capabilities')">
          探索产品方案
          <svg aria-hidden="true" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <path d="M5 12h14M12 5l7 7-7 7" />
          </svg>
        </a>
        <a href="#cta-contact" class="btn-secondary" @click.prevent="scrollTo('#cta-contact')">预约演示</a>
      </div>
    </div>
  </section>
</template>

<script setup lang="ts">
import { ref } from 'vue';
import LazyBg from '@/components/LazyBg.vue';
import { useHeroCanvas } from '@/composables/useHeroCanvas';
import bgSrc from '@/assets/home_bg1.jpg';
import '@/styles/newhome/home/hero.css';

const canvasEl = ref<HTMLCanvasElement | null>(null);
useHeroCanvas(canvasEl);

function scrollTo(selector: string) {
  document.querySelector(selector)?.scrollIntoView({ behavior: 'smooth' });
}
</script>
